import React from 'react';
import './index.css';

function Contact() {
  return (
    <div className="flex flex-col items-center justify-center max-w-4xl mx-auto px-4">
      <div className="text-center mb-8">
        <h2 className="text-3xl font-extrabold mt-2 ">Contact us</h2>
      </div>
      <p className="flex justify-center items-center mb-8">
        <a href="https://wa.me/message/UADIXCEPLCXOF1" target="_blank" rel="noopener noreferrer" className="justify-center text-green-500 hover:text-green-700 transition-colors font-bold text-2xl md:text-4xl flex items-center">
          <i className="fab fa-whatsapp text-4xl mr-4" alt="WhatsApp"></i> <span className="text-lg md:text-2xl">Customer service chat via WhatsApp</span>
        </a>
      </p>
      <div className="flex flex-col md:flex-row justify-center gap-8 md:gap-20">
        
        <div className="space-y-3 text-lg">
          
          <p className="flex items-center">
            <span className="font-semibold w-28">Toll Free:</span>
            <a href="tel:855-351-5466" className="hover:text-blue-600">855-351-LIMO (5466)</a>
          </p>
          <p className="flex items-center">
            <span className="font-semibold w-28">Local:</span>
            <a href="tel:718-937-1177" className="hover:text-blue-600">718-937-1177</a>
          </p>
          <p className="flex items-center">
            <span className="font-semibold w-28">Fax:</span>
            <span>718-706-7722</span>
          </p>
          <p className="flex items-center">
            <span className="font-semibold w-28">Email:</span>
            <a href="mailto:info@a2bcorporatesedan.com" className="hover:text-blue-600">info@a2bcorporatesedan.com</a>
          </p>
          
        </div>

        <div className="flex flex-col items-center mb-8">
          <h3 className="text-xl font-bold mb-4">Follow Us</h3>
          <div className="flex gap-6">
            <a href="https://www.instagram.com/a2bcorporate/" target="_blank" rel="noopener noreferrer" className="text-white hover:text-pink-600 transition-colors">
              <i className="fab fa-instagram text-3xl" alt="Instagram"></i>
            </a>
            {/* <a href="https://www.facebook.com/a2bcorporate" target="_blank" rel="noopener noreferrer" className="text-white hover:text-blue-600 transition-colors">
              <i className="fab fa-facebook text-3xl" alt="Facebook"></i>
            </a> */}
            {/* <a href="https://twitter.com/a2bcorporate" target="_blank" rel="noopener noreferrer" className="text-white hover:text-gray-700 transition-colors">
              <i className="fab fa-x-twitter text-3xl" alt="Twitter"></i>
            </a> */}
          </div>
        </div>
      </div>
      <div className="text-center mt-8">
        <a href="/policy" className="text-white underline hover:text-blue-700 transition-colors">
          Privacy Policy
        </a>
      </div>
    </div>
  );
}

export default Contact;